import { render, staticRenderFns } from "./LandingOld.vue?vue&type=template&id=482f21b4"
import script from "./LandingOld.vue?vue&type=script&lang=ts"
export * from "./LandingOld.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports